/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {platformJsonFilter} from '../../../pages/orgManager/Utils/OrgProfile/Forms/Constants/Common';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const renewableTypeAPI = async (): Promise<any> => {
  const renewableType = useJSONStore.getState().renewableType;
  const token = useUserStore.getState().userToken;
  const setRenewableType = useJSONStore.getState().setRenewableType;

  if (renewableType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.renewableType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRenewableType(platformJsonFilter(res.data.data));
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default renewableTypeAPI;
